module.exports = require("vue3-carousel");